/**
 * Sales inbox agent page: what ToolsAPI's /sales-agent routes answer. Attribute names are the agent's own (the
 * emails table, snake_case); any of them may be missing. Times are ISO UTC, months YYYY-MM.
 */

export const SALES_AGENT_CATEGORIES = ['RFQ', 'ORDER', 'MISC'] as const;
export type SalesAgentCategory = (typeof SALES_AGENT_CATEGORIES)[number];

export type SalesAgentApprovalStatus =
  | 'waiting'
  | 'approved'
  | 'rejected'
  | 'expired';

export interface SalesAgentEmail {
  emailKey: string;
  status?: 'claimed' | 'done' | 'failed';
  received?: string;
  month?: string;
  sender?: string;
  subject?: string;
  category?: SalesAgentCategory;
  confidence?: 'high' | 'medium' | 'low';
  reason?: string;
  mode?: 'shadow' | 'live';
  folder?: string;
  model?: string;
  processed_at?: string;
  error?: string;
  // RFQ proposal
  rfq_lines?: number;
  rfq_matched?: number;
  rfq_price_list?: string;
  rfq_customer?: string;
  rfq_error?: string;
  // Approval of the proposal
  approval_status?: SalesAgentApprovalStatus;
  approval_requested_at?: string;
  approval_by?: string;
  approval_at?: string;
  approval_note?: string;
  quote_num?: number;
  reply_error?: string;
  // Order check
  order_po?: string;
  order_quote_num?: number;
  order_differences?: number;
  order_error?: string;
  // The sales team's review of the category
  review_category?: SalesAgentCategory;
  review_by?: string;
  review_at?: string;
}

export interface SalesAgentEmailSummary {
  emails: number;
  categories: Record<SalesAgentCategory, number>;
  reviewed: number;
  agreed: number;
}

export interface SalesAgentEmails {
  month: string;
  emails: SalesAgentEmail[];
  summary: SalesAgentEmailSummary;
}

export interface SalesAgentApprovalRequest {
  approved: boolean;
  quoteNum?: number;
  note?: string;
}
